<template>
    <dialog-table ref="dialogTable" title="选择产品" :tableList="tableList">
        <template v-slot:searchForm>
            <el-form-item label="">
                <el-input v-model="tableList.searchForm.keyword" placeholder="关键词" clearable></el-input>
            </el-form-item>
        </template>
        <template v-slot:tableColumns>
            <el-table-column property="name" label="产品名称">
            </el-table-column>
            <el-table-column property="code" label="产品编号" width="250"></el-table-column>
            <el-table-column property="remark" label="备注" width="200"></el-table-column>
            <el-table-column
                label="操作"
                width="80">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="primary"
                        @click="onChoose&&onChoose(scope.row, scope.$index)">选择</el-button>
                </template>
            </el-table-column>
        </template>
    </dialog-table>
</template>

<script>
    import List from "@/components/table/List";
    export default {
        name: "ProductListDialog",
        props: {
            onChoose: Function,
        },
        data() {
            return {
                tableList: new List({
                    url: '/product/selectList',
                    pageSize: 10,
                    searchForm: {
                        state: null,
                        type: null,
                    },
                }),
            };
        },
        mounted() {

        },
        computed: {

        },
        methods: {
            show() {
                this.$refs.dialogTable.show();
            },
            hide() {
                this.$refs.dialogTable.hide();
            },
        }
    }
</script>

<style scoped>
    .main-image {
        width: 50px;
        height: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/modules/erp/components/dialog/ProductListDialog.vue